<div *ngIf="!!fieldData">
    <label for="{{fieldData.id}}" class="control-label">
        <span [innerHTML]="htmlTransform(fieldData.metadata.label)"></span>
        <span *ngIf="fieldData.metadata.required" class="required">*</span>
        <img *ngIf="!!fieldData.metadata.fieldInfo" class="tip-icon" src="assets/common/info-icon.svg" placement="right"
            [ngbTooltip]="tipContent" alt="{{fieldData.metadata.label}} {{fieldData.metadata.fieldInfo}}" tabindex="0" role="button"/>
    </label>

    <!-- Tooltip content used with above icon. Note this same block of html exists on other control(s) like textbox. -->
    <ng-template #tipContent>
        <div>
            <div *ngIf="!!fieldData.metadata.fieldInfo && fieldData.metadata.fieldInfo.length > 0" aria-hidden="true">
                {{fieldData.metadata.fieldInfo}}</div>
        </div>
    </ng-template>

    <br />
    <div class="control-container">
        <div class="control-spinner-wrapper" [ngStyle]="{'display':
                    (
                        !!fieldData.metadata.controlOptions.dropdownOptionsStatic ||
                        (!!fieldData.metadata.controlOptions.dropdownOptionsDynamic && !!dynamicDrivenByField && (dynamicDrivenByField.fieldValue !== undefined && dynamicDrivenByField.fieldValue !== null && dynamicDrivenByField.fieldValue !== ''))
                    )}">
            <div
                ngbDropdown
                #bootstrapDropdown="ngbDropdown"
                class="dropdown control-dropdown-wrapper"
                placement="bottom-start"
                [popperOptions]="dropdownPopperOptions"
                (openChange)="onDropdownOpenChange($event)"
                (keydown)="onDropdownKeydown($event, bootstrapDropdown)">
                <button
                    ngbDropdownToggle
                    id="{{fieldData.id}}"
                    type="button"
                    class="form-select control-dropdown"
                    role="combobox"
                    aria-haspopup="listbox"
                    [attr.aria-controls]="fieldData.id + '-menu'"
                    [attr.aria-label]="fieldData.metadata.ariaLabel + fieldData.metadata.fieldInfo"
                    [attr.aria-required]="!!fieldData.metadata.required"
                    [attr.aria-invalid]="isControlInvalid"
                    [attr.aria-busy]="isLoading"
                    [attr.aria-readonly]="!!fieldData.metadata.readOnly"
                    [class.control-invalid]="isControlInvalid"
                    [disabled]="isControlDisabled"
                    (blur)="onDropdownBlur()">
                    <span class="dropdown-value" aria-live="polite">{{selectedOptionText}}</span>
                </button>

                <div
                    ngbDropdownMenu
                    class="control-dropdown-menu"
                    [id]="fieldData.id + '-menu'"
                    role="listbox"
                    [attr.aria-labelledby]="fieldData.id">
                    <button
                        ngbDropdownItem
                        type="button"
                        role="option"
                        [id]="fieldData.id + '-option-0'"
                        [attr.aria-selected]="!hasSelection"
                        (click)="selectOption(null)">
                        {{nothingSelectedText.text}}
                    </button>
                    <button
                        ngbDropdownItem
                        *ngFor="let dataItem of dropdownData; let optionIndex = index"
                        type="button"
                        role="option"
                        [id]="fieldData.id + '-option-' + (optionIndex + 1)"
                        [class.active]="fieldData.fieldValue === dataItem.value"
                        [attr.aria-selected]="fieldData.fieldValue === dataItem.value"
                        (click)="selectOption(dataItem.value)">
                        {{dataItem.text}}
                    </button>
                </div>
            </div>

            <span *ngIf="isLoading" class="spinner-container" role="status" [attr.aria-label]="lms.get('LOADING_ELLIPSIS')">
                <span class="fas fa-spinner fa-pulse" aria-hidden="true"></span>
            </span>
        </div>

        <div class="dynamic-dropdown-drivenby-indicator" [ngStyle]="{'display':
                (
                    !!fieldData.metadata.controlOptions.dropdownOptionsDynamic && !!dynamicDrivenByField && (dynamicDrivenByField.fieldValue === undefined || dynamicDrivenByField.fieldValue === null || dynamicDrivenByField.fieldValue === '')
                ) ? 'inline-block' : 'none'}">
            {{lms.get('PLEASE_SELECT')}} {{!!dynamicDrivenByField ? dynamicDrivenByField.metadata.label : ''}}
        </div>
    </div>
</div>
